import React from 'react';

import { Container } from './styles';

const Header = ({ backgroundColor }) => <Container color={backgroundColor} />;

export default Header;
